import {DefaultPageProps} from "@models/DefaultProps.ts";
import {IGetFormaPagtoFilter} from "@components/formaPagamento/models/GetFormaPagtoFilter.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import React from "react";
import {IFormaPagamento} from "@models/formaPagamento/IFormaPagamento.ts";
import {useFormaPagamento} from "@components/formaPagamento/hooks/useFormaPagamento.ts";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {FormaPagtoInfoRow} from "@components/formaPagamento/info/FormaPagtoInfoRow.tsx";
import usePagination from "@components/shared/hooks/usePagination.tsx";
import useFilters from "@components/shared/hooks/useFilters.tsx";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";

export interface FormasPagamentoPageProps extends DefaultPageProps<IGetFormaPagtoFilter> {

}

export function FormasPagamentoPage(props: FormasPagamentoPageProps) {
    const {getFormasPagamento} = useFormaPagamento()

    const [formasPagamento, setFormasPagamento] = React.useState<IFormaPagamento[]>([])
    const [filters, setFilters] = useFilters(props.filtersProps)

    const getFormasPagamentoHandler = async (p: IPagination) => {
        return await getFormasPagamento({data: filters, pagination: p}).then(x => {
            if (x.items != null) {
                setFormasPagamento(x.items)
            }
            return x;
        })
    }


    const [pagination, setPagination] = usePagination({
        pagination: props.pageProps?.pagination,
        setPagination: props.pageProps?.setPagination,
        triggers: [
            {
                eventName: 'process',
                promise: (p) => getFormasPagamentoHandler(p.pagination).then(x => {
                    setPagination(prev => ({...prev, ...x.pagination}))
                    return x;
                })
            }
        ]
    })


    return (
        <DefaultContainer titulo={'Formas de pagamento'} UpperComponent={<></>} pageProps={{pagination, setPagination}}>
            <TableContainer>
                <Table size={'small'} stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell>Id</TableCell>
                            <TableCell>Nome</TableCell>
                            <TableCell>Ativo</TableCell>
                            <TableCell>Antecipação</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {formasPagamento.map(x => {
                            return <FormaPagtoInfoRow key={x.id} value={x}/>
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </DefaultContainer>)
}